export default function PHP_global() {
  return (
    <div>
      <h1>PHP_global</h1>
    </div>
  );
}
